


























import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import Cookies from "js-cookie";
import { OfficeStaff } from "@/types/mypage";
import { switchStaffWithDeviceGate } from "#/utility/deviceSwitchGate";

@Component
export default class extends Mixins(AxiosMixin) {
  /** 事業所職員一覧 */
  @Prop({ default: () => ({}) }) private readonly item!: OfficeStaff;

  /** 企業名 */
  @Prop({ default: "" }) private readonly corp_name!: string;

  /** データ更新 */
  @Emit() private update() {
    return;
  }

  //iBowを使う
  private clickIbow(item: OfficeStaff) {
    switchStaffWithDeviceGate({
      authBackendUrl: window.base_url,
      axios: window.axios,
      jwt: window.token,
      officeStaffId: item.id,
      onSuccess: (token, refToken) => {
        window.token = token;
        Cookies.set("token", token, {
          domain: window.cookie_domain
        });
        window.reftoken = refToken;
        Cookies.set("reftoken", refToken, {
          domain: window.cookie_domain
        });
        location.href = window.ibow_frontend_url;
      },
      onDenied: (msg: string) => {
        this.$openAlert(msg);
      },
      openAlert: this.$openAlert
    });
  }

  //招待承認
  private async inviteApprove(
    corp_name: string,
    item: OfficeStaff
  ): Promise<void> {
    if (
      !(await this.$openConfirm(
        corp_name + "からの招待を承認します。よろしいですか？"
      ))
    ) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/approve",
      {
        office_staff: item.office_staff
      },
      res => {
        if (res.data.token && res.data.ref_token) {
          window.token = res.data.token;
          Cookies.set("token", res.data.token, {
            domain: window.cookie_domain
          });
          window.reftoken = res.data.ref_token;
          Cookies.set("reftoken", res.data.ref_token, {
            domain: window.cookie_domain
          });
        }
        this.update();
      }
    );
  }
}
